export const ALLOWED_PHONE_PREFIXES = ['9', '8', '3', '4'];

export const normalizePhoneDigits = (value = '') => {
  if (!value) return '';
  let digits = value.replace(/\D/g, '');

  if (value.trim().startsWith('+7') && digits.startsWith('7')) {
    digits = digits.slice(1);
  }
  if (digits.length === 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
    digits = digits.slice(1);
  }

  if (digits && !ALLOWED_PHONE_PREFIXES.includes(digits[0])) {
    const match = digits.match(/[9834]/);
    digits = match ? digits.slice(match.index) : '';
  }

  return digits.slice(0, 10);
};

export const formatPhone = (digits) => {
  if (!digits) return '';
  let result = '+7';
  if (digits.length > 0) {
    result += ' (' + digits.slice(0, Math.min(3, digits.length));
    if (digits.length >= 3) {
      result += ')';
    }
  }
  if (digits.length > 3) {
    result += ' ' + digits.slice(3, Math.min(6, digits.length));
  }
  if (digits.length > 6) {
    result += '-' + digits.slice(6, Math.min(8, digits.length));
  }
  if (digits.length > 8) {
    result += '-' + digits.slice(8, Math.min(10, digits.length));
  }
  return result;
};

export const getCaretPosition = (formattedValue, digitIndex, fallbackPosition = 0) => {
  if (!formattedValue) return 0;
  if (digitIndex <= 0) {
    return fallbackPosition;
  }
  let seen = 0;
  for (let i = 0; i < formattedValue.length; i += 1) {
    if (/\d/.test(formattedValue[i])) {
      if (i < fallbackPosition) {
        continue;
      }
      seen += 1;
      if (seen === digitIndex) {
        return i + 1;
      }
    }
  }
  return formattedValue.length;
};

export const applyPhoneMask = (value = '', selectionStart) => {
  const digits = normalizePhoneDigits(value);
  const hasAnyDigit = /\d/.test(value || '');
  const formatted = digits ? formatPhone(digits) : (hasAnyDigit ? '+7' : '');

  const rawDigits = value.replace(/\D/g, '');
  const trimmedLeading = Math.max(0, rawDigits.length - digits.length);
  const rawBefore = value.slice(0, selectionStart ?? value.length).replace(/\D/g, '');
  const digitsBeforeCount = Math.min(Math.max(0, rawBefore.length - trimmedLeading), digits.length);

  const caretBase = formatted.includes('(') ? formatted.indexOf('(') + 1 : formatted.length;
  const caret = getCaretPosition(formatted, digitsBeforeCount, caretBase);

  return { digits, formatted, caret: formatted === '+7' ? formatted.length : caret };
};
